




import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class RedirectToHome extends Vue {
  mounted() {
    this.$router.push('/');
  }
}
